module.exports = __webpack_public_path__ + "img/icon-conversions.03ea4d79.svg";